// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Unified Search Page ─────────────────────────────────────────────────── */

.ecr-us {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ecr-us__body {
  padding: 24px 40px;
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ── Search bar ──────────────────────────────────────────────────────────── */

.ecr-us__search-bar {
  display: flex;
  align-items: stretch;
  margin-bottom: 20px;
  box-shadow: 0 2px 14px rgba(134, 188, 37, 0.12);
  border-radius: 10px;
}

.ecr-us__field-error {
  color: #b91c1c;
  font-size: 12.5px;
  margin: -14px 0 20px 4px;
}

/* ── Discrepancy alert ───────────────────────────────────────────────────── */

.ecr-us__discrepancy-alert {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ecr-us__discrepancy-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #92400e;
}

.ecr-us__discrepancy-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}

.ecr-us__discrepancy-label {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.ecr-us__discrepancy-label--github {
  background: #fff7ed;
  color: #c2500a;
  border: 1px solid #fed7aa;
}

.ecr-us__discrepancy-label--arbiter {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.ecr-us__discrepancy-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* ── Accordion section title ─────────────────────────────────────────────── */

.ecr-us__section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

/* ── Status chips ────────────────────────────────────────────────────────── */

.ecr-us__chip {
  font-size: 11px !important;
  font-weight: 700 !important;
  height: 20px !important;
}

.ecr-us__chip--ok {
  background: #f0f9e6 !important;
  color: #4d7a10 !important;
}

.ecr-us__chip--warn {
  background: #fff7ed !important;
  color: #c2500a !important;
}

.ecr-us__chip--error {
  background: #fef2f2 !important;
  color: #b91c1c !important;
}

.ecr-us__chip--neutral {
  background: #f1f5f9 !important;
  color: #64748b !important;
}

/* ── Section body ────────────────────────────────────────────────────────── */

.ecr-us__section-body {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ecr-us__sub-heading {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin: 0 0 12px;
}

.ecr-us__empty {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
  padding: 8px 0;
}

.ecr-us__empty--error {
  color: #b91c1c;
}

/* ── Meta row (shared by Arbiter + AD) ──────────────────────────────────── */

.ecr-us__meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 16px;
}

.ecr-us__meta-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 160px;
}

.ecr-us__meta-label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ecr-us__meta-value {
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  word-break: break-all;
}

/* ── Active Directory card ───────────────────────────────────────────────── */

.ecr-us__ad-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 4px;
}

.ecr-us__ad-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #86BC25, #5a8015);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ecr-us__ad-name {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
}

.ecr-us__ad-title {
  margin: 2px 0 0;
  font-size: 13px;
  color: #64748b;
}

/* ── GitHub header ───────────────────────────────────────────────────────── */

.ecr-us__gh-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 4px;
}

.ecr-us__gh-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.ecr-us__gh-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid #86BC25;
  object-fit: cover;
  display: block;
}

.ecr-us__gh-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px;
  height: 18px;
  background: #24292f;
  border-radius: 50%;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.ecr-us__gh-login {
  font-size: 13px;
  color: #86BC25;
  text-decoration: none;
  font-weight: 500;
}

.ecr-us__gh-login:hover {
  text-decoration: underline;
}

.ecr-us__gh-stats {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.ecr-us__gh-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 14px;
  min-width: 50px;
}

.ecr-us__gh-stat-num {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
}

.ecr-us__gh-stat-lbl {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 3px;
}

/* ── Org grid (shared by Arbiter + GitHub) ───────────────────────────────── */

.ecr-us__org-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 8px;
}

.ecr-us__org-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: border-color 0.15s ease;
}

.ecr-us__org-card--issue-github {
  border-color: #fcd34d;
  background: #fffbeb;
}

.ecr-us__org-card--issue-arbiter {
  border-color: #fca5a5;
  background: #fef2f2;
}

.ecr-us__org-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecr-us__org-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}

.ecr-us__org-avatar {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #e2e8f0;
}

.ecr-us__warn-icon {
  font-size: 14px !important;
  color: #f59e0b;
  flex-shrink: 0;
  cursor: help;
}

.ecr-us__warn-icon--red {
  color: #ef4444 !important;
}

/* ── Placeholder (no search yet) ─────────────────────────────────────────── */

.ecr-us__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex: 1 1;
  min-height: 300px;
  margin-top: -100px;
  color: #94a3b8;
  text-align: center;
}

.ecr-us__placeholder p {
  font-size: 14px;
  max-width: 420px;
  line-height: 1.6;
  margin: 0;
}

/* ── Sections wrapper ────────────────────────────────────────────────────── */

.ecr-us__sections {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsUnifiedSearch/EcrOpsUnifiedSearch.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* ── Unified Search Page ─────────────────────────────────────────────────── */\n\n.ecr-us {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.ecr-us__body {\n  padding: 24px 40px;\n  max-width: 1300px;\n  width: 100%;\n  margin: 0 auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ── Search bar ──────────────────────────────────────────────────────────── */\n\n.ecr-us__search-bar {\n  display: flex;\n  align-items: stretch;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 14px rgba(134, 188, 37, 0.12);\n  border-radius: 10px;\n}\n\n.ecr-us__field-error {\n  color: #b91c1c;\n  font-size: 12.5px;\n  margin: -14px 0 20px 4px;\n}\n\n/* ── Discrepancy alert ───────────────────────────────────────────────────── */\n\n.ecr-us__discrepancy-alert {\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  border-left: 4px solid #f59e0b;\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ecr-us__discrepancy-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #92400e;\n}\n\n.ecr-us__discrepancy-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.ecr-us__discrepancy-label {\n  font-size: 12px;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 20px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ecr-us__discrepancy-label--github {\n  background: #fff7ed;\n  color: #c2500a;\n  border: 1px solid #fed7aa;\n}\n\n.ecr-us__discrepancy-label--arbiter {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.ecr-us__discrepancy-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* ── Accordion section title ─────────────────────────────────────────────── */\n\n.ecr-us__section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* ── Status chips ────────────────────────────────────────────────────────── */\n\n.ecr-us__chip {\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  height: 20px !important;\n}\n\n.ecr-us__chip--ok {\n  background: #f0f9e6 !important;\n  color: #4d7a10 !important;\n}\n\n.ecr-us__chip--warn {\n  background: #fff7ed !important;\n  color: #c2500a !important;\n}\n\n.ecr-us__chip--error {\n  background: #fef2f2 !important;\n  color: #b91c1c !important;\n}\n\n.ecr-us__chip--neutral {\n  background: #f1f5f9 !important;\n  color: #64748b !important;\n}\n\n/* ── Section body ────────────────────────────────────────────────────────── */\n\n.ecr-us__section-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.ecr-us__sub-heading {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  margin: 0 0 12px;\n}\n\n.ecr-us__empty {\n  font-size: 14px;\n  color: #94a3b8;\n  margin: 0;\n  padding: 8px 0;\n}\n\n.ecr-us__empty--error {\n  color: #b91c1c;\n}\n\n/* ── Meta row (shared by Arbiter + AD) ──────────────────────────────────── */\n\n.ecr-us__meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 32px;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f5f9;\n  margin-bottom: 16px;\n}\n\n.ecr-us__meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 160px;\n}\n\n.ecr-us__meta-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.ecr-us__meta-value {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1e293b;\n  word-break: break-all;\n}\n\n/* ── Active Directory card ───────────────────────────────────────────────── */\n\n.ecr-us__ad-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 4px;\n}\n\n.ecr-us__ad-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #86BC25, #5a8015);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ecr-us__ad-name {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.ecr-us__ad-title {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #64748b;\n}\n\n/* ── GitHub header ───────────────────────────────────────────────────────── */\n\n.ecr-us__gh-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f1f5f9;\n  margin-bottom: 4px;\n}\n\n.ecr-us__gh-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.ecr-us__gh-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  border: 2px solid #86BC25;\n  object-fit: cover;\n  display: block;\n}\n\n.ecr-us__gh-badge {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 18px;\n  height: 18px;\n  background: #24292f;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.ecr-us__gh-login {\n  font-size: 13px;\n  color: #86BC25;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.ecr-us__gh-login:hover {\n  text-decoration: underline;\n}\n\n.ecr-us__gh-stats {\n  display: flex;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.ecr-us__gh-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 6px 14px;\n  min-width: 50px;\n}\n\n.ecr-us__gh-stat-num {\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1;\n}\n\n.ecr-us__gh-stat-lbl {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-top: 3px;\n}\n\n/* ── Org grid (shared by Arbiter + GitHub) ───────────────────────────────── */\n\n.ecr-us__org-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 8px;\n}\n\n.ecr-us__org-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  transition: border-color 0.15s ease;\n}\n\n.ecr-us__org-card--issue-github {\n  border-color: #fcd34d;\n  background: #fffbeb;\n}\n\n.ecr-us__org-card--issue-arbiter {\n  border-color: #fca5a5;\n  background: #fef2f2;\n}\n\n.ecr-us__org-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1e293b;\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ecr-us__org-badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 20px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  letter-spacing: 0.03em;\n}\n\n.ecr-us__org-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid #e2e8f0;\n}\n\n.ecr-us__warn-icon {\n  font-size: 14px !important;\n  color: #f59e0b;\n  flex-shrink: 0;\n  cursor: help;\n}\n\n.ecr-us__warn-icon--red {\n  color: #ef4444 !important;\n}\n\n/* ── Placeholder (no search yet) ─────────────────────────────────────────── */\n\n.ecr-us__placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex: 1;\n  min-height: 300px;\n  margin-top: -100px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.ecr-us__placeholder p {\n  font-size: 14px;\n  max-width: 420px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ── Sections wrapper ────────────────────────────────────────────────────── */\n\n.ecr-us__sections {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
